import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useImperativeHandle,
} from "react";
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";
import { loadAllPublicSongs } from "../../../../../../store/PublicPlaylists/actions";

import List from "../../../../../../components/DraggableList";
import SongItem from "../../AllSongs/Songs";

import SvgArrowDownLight from "../../../../../../components/SVG/ArrowDownLight";
import ListNew from "../../../../../../components/DraggableList/ListNew";

export const AllPublicSongs = React.forwardRef(
  (
    {
      preset = "audio",
      songRenderItem,

      toggleSelectedP,

      loadMorePublicTraks: loadMorePublicTraksInner,
    },
    ref,
  ) => {
    const { list, loading, loaded_all, selected } = useSelector((state) => {
      let list, loading, loaded_all, selected;

      switch (preset) {
        case "audio":
          list = state.public_playlists.allPublicTracks;
          loading = state.public_playlists.allPublicTracks_loading;
          selected = state.public_playlists.selected_song;
          loaded_all = state.public_playlists.allPublicTracks_loadedAll;
          break;

        case "public_audio":
          list = state.public_playlists.assocPublicTracks;
          loading = state.public_playlists.allPublicTracks_loading;
          loaded_all = state.public_playlists.assocPublicTracks_loadedAll;
          selected = state.public_playlists.selected_song;
          break;

        case "playlist_video":
          list = state.videolists_all.songs;
          loading = state.videolists_all.songs_loading;
          loaded_all = state.videolists_all.songs_loaded_all;
          selected = state.videolists_all.selected_video;
          break;

        case "video":
          list = state.videolists.allPublicVideos;
          loading = state.videolists.allPublicVideos_loading;
          loaded_all = state.videolists.allPublicVideos_loaded_all;
          selected = state.videolists_all.selected_video;
          break;
      }

      return {
        list,
        loading,
        loaded_all,
        selected,
      };
    });

    const getSelectedTracks = () => {
      return [...list.values()].filter(
        (song) => selected.indexOf(song.id) !== -1,
      );
    };

    const getTrackByIndex = (index) => {
      return [...list.values()][index];
    };
    const getTracks = () => {
      return [...list.values()];
    };

    useImperativeHandle(ref, () => ({
      getSelectedTracks,
      getTrackByIndex,
      getTracks,
    }));

    const loadMorePublicTraks = () => loadMorePublicTraksInner(true);

    const getItems = () => {
      if (!list) return [];

      try {
        if (Array.isArray(list))
          return list.map((song, index) =>
            songRenderItem(song, index, selected),
          );

        return [...list.values()].map((song, index) =>
          songRenderItem(song, index, selected),
        );
      } catch (error) {
        console.error("AllPublicSongs => ", error);

        return [];
      }
    };

    return (
      <ListNew
        type="simple"
        // offset={offset}
        loading={loading}
        loaded_all={loaded_all}
        offsetAdd={50}
        // loadButton={!loading && <div className="ScrollContainer__more">
        //     <div onClick={loadMorePublicTraks}>
        //         Загрузить ещё
        //         <SvgArrowDownLight title="Загрузить ещё" variant="dark" size="xs" />
        //     </div>
        // </div>}
        loadMore={loadMorePublicTraks}
        scroll={{
          on: true,
          data: {
            variant: "white",
            size: "sm",
          },
        }}
        onClick={toggleSelectedP}
        content={{ items: getItems(), variant: "none" }}
        droppableId={`1`}
      // dnd_disabled
      />
    );
  },
);

export default AllPublicSongs;
// Line 37:24:  'SongItem' is not defined              react/jsx-no-undef
// Line 42:24:  'songs' is not defined                 no-undef
// Line 43:27:  'selected_public_song' is not defined  no-undef
// Line 58:24:  'audio' is not defined                 no-undef
// Line 59:31:  'trackPlaying' is not defined          no-undef
// Line 60:28:  'isPlaying' is not defined             no-undef
// Line 61:23:  'hPlay' is not defined                 no-undef
// Line 62:24:  'hPause' is not defined                no-undef
// Line 63:23:  'hStop' is not defined                 no-undef
// Line 64:25:  'hRewind' is not defined               no-undef
// Line 75:41:  'all_public_tracks' is not defined     no-undef
// Line 78:22:  'SvgArrowDownLight' is not defined     react/jsx-no-undef
// Line 88:22:  'toggleSelectedP' is not defined       no-undef
